export default function useSupport () {
  const companyCountryList = {
    en: [
      'Afghanistan',
      'Albania',
      'Algeria',
      'American Samoa',
      'Andorra',
      'Angola',
      'Anguilla',
      'Antarctica',
      'Antigua and Barbuda',
      'Argentina',
      'Armenia',
      'Aruba',
      'Australia',
      'Austria',
      'Azerbaijan',
      'Bahamas',
      'Bahrain',
      'Bangladesh',
      'Barbados',
      'Belarus',
      'Belgium',
      'Belize',
      'Benin',
      'Bermuda',
      'Bhutan',
      'Bolivia',
      'Bosnia and Herzegovina',
      'Botswana',
      'Brazil',
      'British Indian Ocean Territory',
      'British Virgin Islands',
      'Brunei',
      'Bulgaria',
      'Burkina Faso',
      'Myanmar',
      'Burundi',
      'Cambodia',
      'Cameroon',
      'Canada',
      'Cape Verde',
      'Cayman Islands',
      'Central African Republic',
      'Chad',
      'Chile',
      'China',
      'Christmas Island',
      'Cocos Islands',
      'Colombia',
      'Comoros',
      'Republic of the Congo',
      'Democratic Republic of the Congo',
      'Cook Islands',
      'Costa Rica',
      'Croatia',
      'Cuba',
      'Curacao',
      'Cyprus',
      'Czech Republic',
      'Denmark',
      'Djibouti',
      'Dominica',
      'Dominican Republic',
      'Dominican Republic',
      'Dominican Republic',
      'East Timor',
      'Ecuador',
      'Egypt',
      'El Salvador',
      'Equatorial Guinea',
      'Eritrea',
      'Estonia',
      'Ethiopia',
      'Falkland Islands',
      'Faroe Islands',
      'Fiji',
      'Finland',
      'France',
      'French Polynesia',
      'Gabon',
      'Gambia',
      'Georgia',
      'Germany',
      'Ghana',
      'Gibraltar',
      'Greece',
      'Greenland',
      'Grenada',
      'Guam',
      'Guatemala',
      'Guernsey',
      'Guinea',
      'Guinea-Bissau',
      'Guyana',
      'Haiti',
      'Honduras',
      'Hong Kong',
      'Hungary',
      'Iceland',
      'India',
      'Indonesia',
      'Iran',
      'Iraq',
      'Ireland',
      'Isle of Man',
      'Israel',
      'Italy',
      'Ivory Coast',
      'Jamaica',
      'Japan',
      'Jersey',
      'Jordan',
      'Kazakhstan',
      'Kenya',
      'Kiribati',
      'Kosovo',
      'Kuwait',
      'Kyrgyzstan',
      'Laos',
      'Latvia',
      'Lebanon',
      'Lesotho',
      'Liberia',
      'Libya',
      'Liechtenstein',
      'Lithuania',
      'Luxembourg',
      'Macau',
      'Macedonia',
      'Madagascar',
      'Malawi',
      'Malaysia',
      'Maldives',
      'Mali',
      'Malta',
      'Marshall Islands',
      'Mauritania',
      'Mauritius',
      'Mayotte',
      'Mexico',
      'Micronesia',
      'Moldova',
      'Monaco',
      'Mongolia',
      'Montenegro',
      'Montserrat',
      'Morocco',
      'Mozambique',
      'Namibia',
      'Nauru',
      'Nepal',
      'Netherlands',
      'Netherlands Antilles',
      'New Caledonia',
      'New Zealand',
      'Nicaragua',
      'Niger',
      'Nigeria',
      'Niue',
      'Northern Mariana Islands',
      'North Korea',
      'Norway',
      'Oman',
      'Pakistan',
      'Palau',
      'Palestine',
      'Panama',
      'Papua New Guinea',
      'Paraguay',
      'Peru',
      'Philippines',
      'Pitcairn',
      'Poland',
      'Portugal',
      'Puerto Rico',
      'Puerto Rico',
      'Qatar',
      'Reunion',
      'Romania',
      'Russia',
      'Rwanda',
      'Saint Barthelemy',
      'Samoa',
      'San Marino',
      'Sao Tome and Principe',
      'Saudi Arabia',
      'Senegal',
      'Serbia',
      'Seychelles',
      'Sierra Leone',
      'Singapore',
      'Sint Maarten',
      'Slovakia',
      'Slovenia',
      'Solomon Islands',
      'Somalia',
      'South Africa',
      'South Korea',
      'South Sudan',
      'Spain',
      'Sri Lanka',
      'Saint Helena',
      'Saint Kitts and Nevis',
      'Saint Lucia',
      'Saint Martin',
      'Saint Pierre and Miquelon',
      'Saint Vincent and the Grenadines',
      'Sudan',
      'Suriname',
      'Svalbard and Jan Mayen',
      'Swaziland',
      'Sweden',
      'Switzerland',
      'Syria',
      'Taiwan China',
      'Tajikistan',
      'Tanzania',
      'Thailand',
      'Togo',
      'Tokelau',
      'Tonga',
      'Trinidad and Tobago',
      'Tunisia',
      'Turkey',
      'Turkmenistan',
      'Turks and Caicos Islands',
      'Tuvalu',
      'United Arab Emirates',
      'Uganda',
      'United Kingdom',
      'Ukraine',
      'Uruguay',
      'United States',
      'Uzbekistan',
      'Vanuatu',
      'Vatican',
      'Venezuela',
      'Vietnam',
      'U.S. Virgin Islands',
      'Wallis and Futuna',
      'Western Sahara',
      'Yemen',
      'Zambia',
      'Zimbabwe'
    ],
    pt: [
      'Afeganistão',
      'Albânia',
      'Argélia',
      'Samoa Americana',
      'Andorra',
      'Angola',
      'Anguila',
      'Antártica',
      'Antígua e Barbuda',
      'Argentina',
      'Armênia',
      'Aruba',
      'Austrália',
      'Áustria',
      'Azerbaijão',
      'Bahamas',
      'Bahrein',
      'Bangladesh',
      'Barbados',
      'Bielorrússia',
      'Bélgica',
      'Belize',
      'Benin',
      'Bermudas',
      'Butão',
      'Bolívia',
      'Bósnia e Herzegovina',
      'Botsuana',
      'Brasil',
      'Território Britânico do Oceano Índico',
      'Reino Unido Virgem Ilhas',
      'Brunei',
      'Bulgária',
      'Burkina Faso',
      'Mianmar',
      'Burundi',
      'Camboja',
      'Camarões',
      'Canadá',
      'Cabo Verde',
      'Ilhas Cayman',
      'República Centro-Africana',
      'Chade',
      'Chile',
      'China',
      'Ilha Christmas',
      'Ilhas Cocos',
      'Colômbia',
      'Comores',
      'República do Congo',
      'Congo',
      'Ilhas Cook',
      'Costa Rica Rica',
      'Croácia',
      'Cuba',
      'Curaçao',
      'Chipre',
      'República Checa',
      'Dinamarca',
      'Djibuti',
      'Dominica',
      'República Dominicana',
      'República Dominicana',
      'República Dominicana',
      'Timor Leste',
      'Equador',
      'Egito',
      'El Salvador',
      'Guiné Equatorial',
      'Eritreia',
      'Estónia',
      'Etiópia',
      'Ilhas Malvinas',
      'Faroé Ilhas',
      'Fiji',
      'Finlândia',
      'França',
      'Polinésia Francesa',
      'Gabão',
      'Gâmbia',
      'Geórgia',
      'Alemanha',
      'Gana',
      'Gibraltar',
      'Grécia',
      'Groenlândia',
      'Granada',
      'Guam',
      'Guatemala',
      'Guernsey',
      'Guiné',
      'Guiné-Bissau',
      'Guiana',
      'Haiti',
      'Honduras',
      'Hong Kong',
      'Hungria',
      'Islândia',
      'Índia',
      'Indonésia',
      'Irã',
      'Iraque',
      'Irlanda',
      'Ilha de Man',
      'Israel',
      'Itália',
      'Marfim Costa',
      'Jamaica',
      'Japão',
      'Jersey',
      'Jordânia',
      'Cazaquistão',
      'Quênia',
      'Kiribati',
      'Kosovo',
      'Kuwait',
      'Quirguistão',
      'Laos',
      'Letônia',
      'Líbano',
      'Lesoto',
      'Lib área',
      'Líbia',
      'Liechtenstein',
      'Lituânia',
      'Luxemburgo',
      'Macau',
      'Macedônia',
      'Madagascar',
      'Malawi',
      'Malásia',
      'Maldivas',
      'Mali',
      'Malta',
      'Marshall Ilhas',
      'Mauritânia',
      'Maurícias',
      'Mayotte',
      'México',
      'Micronésia',
      'Moldávia',
      'Mónaco',
      'Mongólia',
      'Montenegro',
      'Montserrat',
      'Marrocos',
      'Moçambique',
      'Namíbia',
      'Nauru',
      'Nepal',
      'Países Baixos',
      'Índias Ocidentais Holandesas',
      'Nova Caledónia',
      'Nova Zelândia',
      'Nicarágua',
      'Níger',
      'Nigéria',
      'Niue',
      'Ilhas Marianas do Norte',
      'Norte Coréia',
      'Noruega',
      'Omã',
      'Paquistão',
      'Palau',
      'Palestina',
      'Panamá',
      'Papua Nova Guiné',
      'Paraguai',
      'Peru',
      'Filipinas',
      'Pitcairn',
      'Polônia',
      'Portugal',
      'Porto Rico',
      'Porto Rico',
      'Catar',
      'Reunião',
      'Romênia',
      'Rússia',
      'Ruanda',
      'São Bartolomeu',
      'Samoa',
      'San Marino',
      'São Tomé e Príncipe',
      'Arábia Saudita Arábia',
      'Senegal',
      'Sérvia',
      'Seicheles',
      'Serra Leoa',
      'Singapura',
      'São Martinho',
      'Eslováquia',
      'Eslovénia',
      'Ilhas Salomão',
      'Somália',
      'África do Sul',
      'Coreia do Sul',
      'Sudão do Sul',
      'Espanha',
      'Sri Lanka',
      'Santa Helena',
      'São Cristóvão e Nevis',
      'Santa Lúcia',
      'São Martinho',
      'São Pedro e Miquelão',
      'São Granadinas',
      'Sudão',
      'Suriname',
      'Svalbard e Jan Mayen',
      'Suazilândia',
      'Suécia',
      'Suíça',
      'Síria',
      'Taiwan China',
      'Tajiquistão',
      'Tanzânia',
      'Tailândia',
      'Togo',
      'Tokelau',
      'Tonga',
      'Trinidad e Tobago',
      'Tunísia',
      'Turquia',
      'Turquemenistão',
      'Ilhas Turks e Caicos',
      'Tuvalu',
      'Emirados Árabes Unidos Emirados',
      'Uganda',
      'Reino Unido',
      'Ucrânia',
      'Uruguai',
      'Estados Unidos',
      'Uzbequistão',
      'Vanuatu',
      'Vaticano',
      'Venezuela',
      'Vietnã',
      'EUA. Ilhas Virgens',
      'Wallis e Futuna',
      'Sahara Ocidental',
      'Iémen',
      'Zâmbia',
      'Zimbabué'
    ],
    es: [
      'Afganistán',
      'Albania',
      'Argelia',
      'Samoa Americana',
      'Andorra',
      'Angola',
      'Anguila',
      'Antártida',
      'Antigua y Barbuda',
      'Argentina',
      'Armenia',
      'Aruba',
      'Australia',
      'Austria',
      'Azerbaiyán',
      'Bahamas',
      'Bahrein',
      'Bangladesh',
      'Barbados',
      'Bielorrusia',
      'Bélgica',
      'Belice',
      'Benin',
      'Bermudas',
      'Bután',
      'Bolivia',
      'Bosnia y Herzegovina',
      'Botswana',
      'Brasil',
      'Territorio Británico del Océano Índico',
      'Británico Virgen Brunei',
      'Bulgaria',
      'Burkina Faso',
      'Myanmar',
      'Burundi',
      'Camboya',
      'Camerún',
      'Canadá',
      'Cabo Verde',
      'Islas Caimán',
      'República Centroafricana',
      'Chad',
      'Chile',
      'China',
      'Isla de Navidad',
      'Islas Cocos',
      'Colombia',
      'Comoras',
      'República del Congo',
      'Congo',
      'Islas Cook',
      'Costa Rica Rica',
      'Croacia',
      'Cuba',
      'Curazao',
      'Chipre',
      'República Checa',
      'Dinamarca',
      'Djibouti',
      'Dominica',
      'República Dominicana',
      'República Dominicana',
      'República Dominicana',
      'Timor Oriental',
      'Ecuador',
      'Egipto',
      'El Salvador',
      'Guinea Ecuatorial',
      'Eritrea',
      'Estonia',
      'Etiopía',
      'Islas Malvinas',
      'Feroe Islas',
      'Fiji',
      'Finlandia',
      'Francia',
      'Polinesia Francesa',
      'Gabón',
      'Gambia',
      'Georgia',
      'Alemania',
      'Ghana',
      'Gibraltar',
      'Grecia',
      'Groenlandia',
      'Granada',
      'Guam',
      'Guatemala',
      'Guernsey',
      'Guinea',
      'Guinea-Bissau',
      'Guyana',
      'Haití',
      'Honduras',
      'Hong Kong',
      'Hungría',
      'Islandia',
      'India',
      'Indonesia',
      'Irán',
      'Irak',
      'Irlanda',
      'Isla de Man',
      'Israel',
      'Italia',
      'Marfil Costa',
      'Jamaica',
      'Japón',
      'Jersey',
      'Jordania',
      'Kazajstán',
      'Kenia',
      'Kiribati',
      'Kosovo',
      'Kuwait',
      'Kirguistán',
      'Laos',
      'Letonia',
      'Líbano',
      'Lesoto',
      'Lib área',
      'Libia',
      'Liechtenstein',
      'Lituania',
      'Luxemburgo',
      'Macao',
      'Macedonia',
      'Madagascar',
      'Malawi',
      'Malasia',
      'Maldivas',
      'Malí',
      'Malta',
      'Marshall Islas',
      'Mauritania',
      'Mauricio',
      'Mayotte',
      'México',
      'Micronesia',
      'Moldavia',
      'Mónaco',
      'Mongolia',
      'Montenegro',
      'Montserrat',
      'Marruecos',
      'Mozambique',
      'Namibia',
      'Nauru',
      'Nepal',
      'Países Bajos',
      'Antillas Holandesas',
      'Nueva Caledonia',
      'Nueva Zelanda',
      'Nicaragua',
      'Níger',
      'Nigeria',
      'Niue',
      'Islas Marianas del Norte',
      'Norte Corea',
      'Noruega',
      'Omán',
      'Pakistán',
      'Palau',
      'Palestina',
      'Panamá',
      'Papua Nueva Guinea',
      'Paraguay',
      'Perú',
      'Filipinas',
      'Pitcairn',
      'Polonia',
      'Portugal',
      'Puerto Rico',
      'Puerto Rico',
      'Qatar',
      'Reunión',
      'Rumania',
      'Rusia',
      'Ruanda',
      'San Bartolomé',
      'Samoa',
      'San Marino',
      'Santo Tomé y Príncipe',
      'Arabia Saudita Arabia',
      'Senegal',
      'Serbia',
      'Seychelles',
      'Sierra Leona',
      'Singapur',
      'Sint Maarten',
      'Eslovaquia',
      'Eslovenia',
      'Islas Salomón',
      'Somalia',
      'Sudáfrica',
      'Corea del Sur',
      'Sudán del Sur',
      'España',
      'Sri Lanka',
      'Santa Elena',
      'San Cristóbal y Nieves',
      'Santa Lucía',
      'San Martín',
      'San Pedro y Miquelón',
      'San Granadinas',
      'Sudán',
      'Surinam',
      'Svalbard y Jan Mayen',
      'Suazilandia',
      'Suecia',
      'Suiza',
      'Siria',
      'Taiwán',
      'China',
      'Tayikistán',
      'Tanzania',
      'Tailandia',
      'Togo',
      'Tokelau',
      'Tonga',
      'Trinidad y Tobago',
      'Túnez',
      'Turquía',
      'Turkmenistán',
      'Islas Turcas y Caicos',
      'Tuvalu.',
      'Emiratos Árabes Unidos Emiratos',
      'Uganda',
      'Reino Unido',
      'Ucrania',
      'Uruguay',
      'Estados Unidos',
      'Uzbekistán',
      'Vanuatu',
      'Vaticano',
      'Venezuela',
      'Vietnam',
      'EE. UU. Islas Vírgenes',
      'Wallis y Futuna',
      'Sáhara Occidental',
      'Yemen',
      'Zambia',
      'Zimbabwe'
    ],
    zh: [
      '阿富汗',
      '阿尔巴尼亚',
      '阿尔及利亚',
      '美属萨摩亚',
      '安道尔',
      '安哥拉',
      '安圭拉',
      '南极洲',
      '安提瓜和巴布达',
      '阿根廷',
      '亚美尼亚',
      '阿鲁巴',
      '澳大利亚',
      '奥地利',
      '阿塞拜疆',
      '巴哈马',
      '巴林',
      '孟加拉国',
      '巴巴多斯',
      '白俄罗斯',
      '比利时',
      '伯利兹',
      '贝宁',
      '百慕大',
      '不丹',
      '玻利维亚',
      '波斯尼亚和黑塞哥维那',
      '博茨瓦纳',
      '巴西',
      '英属印度洋领地',
      '英国处女群岛',
      '文莱',
      '保加利亚',
      '布基纳法索',
      '缅甸',
      '布隆迪',
      '柬埔寨',
      '喀麦隆',
      '加拿大',
      '佛得角',
      '开曼群岛',
      '中非共和国',
      '乍得',
      '智利',
      '中国',
      '圣诞岛',
      '科科斯群岛',
      '哥伦比亚',
      '科摩罗',
      '刚果共和国',
      '刚果',
      '库克群岛',
      '哥斯达黎加黎加',
      '克罗地亚',
      '古巴',
      '库拉索',
      '塞浦路斯',
      '捷克共和国',
      '丹麦',
      '吉布提',
      '多米尼加',
      '多米尼加共和国',
      '多米尼加共和国',
      '多米尼加共和国',
      '东帝汶',
      '厄瓜多尔',
      '埃及',
      '萨尔瓦多',
      '赤道几内亚',
      '厄立特里亚',
      '爱沙尼亚',
      '埃塞俄比亚',
      '福克兰群岛',
      '法罗群岛群岛',
      '斐济',
      '芬兰',
      '法国',
      '法属波利尼西亚',
      '加蓬',
      '冈比亚',
      '格鲁吉亚',
      '德国',
      '加纳',
      '直布罗陀',
      '希腊',
      '格陵兰岛',
      '格林纳达',
      '关岛',
      '危地马拉',
      '根西岛',
      '几内亚',
      '几内亚比绍',
      '圭亚那',
      '海地',
      '洪都拉斯',
      '香港香港',
      '匈牙利',
      '冰岛',
      '印度',
      '印度尼西亚',
      '伊朗',
      '伊拉克',
      '爱尔兰',
      '马恩岛',
      '以色列',
      '意大利',
      '象牙海岸',
      '牙买加',
      '日本',
      '泽西岛',
      '约旦',
      '哈萨克斯坦',
      '肯尼亚',
      '基里巴斯',
      '科索沃',
      '科威特',
      '吉尔吉斯斯坦',
      '老挝',
      '拉脱维亚',
      '黎巴嫩',
      '莱索托',
      '利比亚地区',
      '利比亚',
      '列支敦士登',
      '立陶宛',
      '卢森堡',
      '澳门',
      '马其顿',
      '马达加斯加',
      '马拉维',
      '马来西亚',
      '马尔代夫',
      '马里',
      '马耳他',
      '马歇尔群岛',
      '毛里塔尼亚',
      '毛里求斯',
      '马约特岛',
      '墨西哥',
      '密克罗尼西亚',
      '摩尔多瓦',
      '摩纳哥',
      '蒙古',
      '黑山',
      '蒙特塞拉特',
      '摩洛哥',
      '莫桑比克',
      '纳米比亚',
      '瑙鲁',
      '尼泊尔',
      '荷兰',
      '荷兰西印度群岛',
      '新喀里多尼亚',
      '新西兰',
      '尼加拉瓜',
      '尼日尔',
      '尼日利亚',
      '纽埃',
      '北马里亚纳群岛',
      '北部韩国',
      '挪威',
      '阿曼',
      '巴基斯坦',
      '帕劳',
      '巴勒斯坦',
      '巴拿马',
      '巴布亚新几内亚',
      '巴拉圭',
      '秘鲁',
      '菲律宾',
      '皮特凯恩',
      '波兰',
      '葡萄牙',
      '波多黎各',
      '波多黎各',
      '卡塔尔',
      '留尼旺',
      '罗马尼亚',
      '俄罗斯',
      '卢旺达',
      '圣巴泰勒米',
      '萨摩亚',
      '圣马力诺',
      '圣多美和普林西比',
      '沙特阿拉伯阿拉伯',
      '塞内加尔',
      '塞尔维亚',
      '塞舌尔',
      '塞拉利昂',
      '新加坡',
      '圣马丁',
      '斯洛伐克',
      '斯洛文尼亚',
      '所罗门群岛',
      '索马里',
      '南非',
      '韩国',
      '南苏丹',
      '西班牙',
      '斯里兰卡',
      '圣赫勒拿',
      '圣基茨和尼维斯',
      '圣卢西亚',
      '圣马丁',
      '圣彼得和密克隆群岛',
      '圣马丁格林纳丁斯',
      '苏丹',
      '苏里南',
      '斯瓦尔巴和扬马延',
      '斯威士兰',
      '瑞典',
      '瑞士',
      '叙利亚',
      '中国台湾',
      '塔吉克斯坦',
      '坦桑尼亚',
      '泰国',
      '多哥',
      '托克劳',
      '汤加',
      '特立尼达和多巴哥',
      '突尼斯',
      '土耳其',
      '土库曼斯坦',
      '特克斯和凯科斯群岛',
      '图瓦卢',
      '阿拉伯联合酋长国阿联酋',
      '乌干达',
      '英国',
      '乌克兰',
      '乌拉圭',
      '美国',
      '乌兹别克斯坦',
      '瓦努阿图',
      '梵蒂冈',
      '委内瑞拉',
      '越南',
      '美国维尔京群岛',
      '瓦利斯和富图纳群岛',
      '西撒哈拉',
      '也门',
      '赞比亚',
      '津巴布韦'
    ]
  }

  return {
    companyCountryList
  }
}
